document.addEventListener("DOMContentLoaded", () => {
    const openPopupButtonHigh = document.getElementById("open-popup-high"); // Button to open the popup
    if (!openPopupButtonHigh) return; // ✅ prevent error on non-home pages
    const popupHigh = document.getElementById("investment-popup-high"); // Popup container
    const closePopupButtonHigh = document.getElementById("close-popup-high"); // Close button
    const checkbox = document.getElementById("accept_agb_monthly"); // Checkbox element

    // Function to toggle the button state
    const toggleButton_monthly = () => {
        const button = document.getElementById("btn-monthly");
        if (button) {
            button.disabled = !checkbox.checked;
        }
    };

    // Open the popup
    openPopupButtonHigh.addEventListener("click", () => {
        popupHigh.style.display = "block";
        if (checkbox) {
            checkbox.checked = false; // Reset checkbox state
            toggleButton_monthly();
        }
    });

    // Close the popup when clicking the close button
    closePopupButtonHigh.addEventListener("click", () => {
        popupHigh.style.display = "none";
    });

    // Close the popup when clicking outside the popup container
    document.addEventListener("click", (event) => {
        // console.log('click');
        // Check if the click target is outside the popup container
        if (!openPopupButtonHigh.contains(event.target) &&!popupHigh.contains(event.target) && popupHigh.style.display === "block") {
            // console.log('click1');
            popupHigh.style.display = "none";
        }
    });

    // Checkbox change event
    if (checkbox) {
        checkbox.addEventListener("change", toggleButton_monthly);
    }

    // Close popup when pressing the Escape key
    document.addEventListener("keydown", (event) => {
        if (event.key === "Escape" && popupHigh.style.display === "block") {
            popupHigh.style.display = "none";
        }
    });
});